import FindFolderRequest from 'owa-service/lib/contract/FindFolderRequest';
import FindFolderResponseMessage from 'owa-service/lib/contract/FindFolderResponseMessage';
import findFolderOperation from 'owa-service/lib/operation/findFolderOperation';
import findFolderRequest from 'owa-service/lib/factory/findFolderRequest';
import folderResponseShape from 'owa-service/lib/factory/folderResponseShape';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import BaseFolderId from 'owa-service/lib/contract/BaseFolderId';
import FolderId from 'owa-service/lib/contract/FolderId';
import getDefaultRequestOptions from './getDefaultRequestOptions';

function configureRequestBody(baseFolderId: BaseFolderId): FindFolderRequest {
    return findFolderRequest({
        FolderShape: folderResponseShape({
            BaseShape: 'IdOnly',
            AdditionalProperties: [
                propertyUri({ FieldURI: 'DistinguishedFolderId' }),
                propertyUri({ FieldURI: 'FolderClass' }),
                propertyUri({ FieldURI: 'FolderDisplayName' }),
                propertyUri({ FieldURI: 'ParentFolderId' }),
                propertyUri({ FieldURI: 'TotalCount' }),
                propertyUri({ FieldURI: 'UnreadCount' }),
            ],
        }),
        Paging: null,
        ParentFolderIds: [baseFolderId],
        ReturnParentFolder: true,
        ShapeName: 'Folder',
        Traversal: 'Deep',
    });
}

export default function findFolders(
    baseFolderId: BaseFolderId
): Promise<FindFolderResponseMessage> {
    const folderId = baseFolderId as FolderId;
    let requestBody = configureRequestBody(folderId);
    return findFolderOperation(
        {
            Header: getJsonRequestHeader(),
            Body: requestBody,
        },
        getDefaultRequestOptions(folderId.Id)
    ).then(response => {
        return response.Body.ResponseMessages.Items[0] as FindFolderResponseMessage;
    });
}
